import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, forkJoin, of } from 'rxjs';
import { takeUntil, catchError, switchMap } from 'rxjs/operators';
import { IGetCodes, IGetCodesName, IStudyUnitPracticeTest } from 'src/app/interfaces/codes';
import { IMockExam, ICoursePlanMockExam } from 'src/app/Models/ExamAgencies';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { AssignStudyunitToPracticeTestComponent } from '../assign-studyunit-to-practice-test/assign-studyunit-to-practice-test.component';
import { StudyunitPracticeTestService } from 'src/app/Services/studyunit-practice-test.service';
import { error } from 'jquery';

@Component({
  selector: 'app-add-studymaterial-practice-test',
  templateUrl: './add-studymaterial-practice-test.component.html',
  styleUrls: ['./add-studymaterial-practice-test.component.css']
})
export class AddStudymaterialPracticeTestComponent implements OnInit {
  @Input() PracticeTest: IStudyUnitPracticeTest;
  @Input() subjectId: number | undefined;
  addEditForm: FormGroup;
  statuses: IGetCodes[] = [];
  subjects: IGetCodesName[] = [];
  courses: IGetCodes[] = [];
  selectedCourses: string[] = [];
  courseId: number;
  availableCourseType: any[] = [];
  CourseAppliableCourseType: string[] =[];
  private destroy$ = new Subject<void>();
  examSeriesType: IGetCodes[];
  studyUnitId: number;
  studyUnitName: any;
  studyUnitTopic: any;

  private asArray<T>(value: any): T[] {
    if (Array.isArray(value)) {
      return value;
    }

    if (value && typeof value === 'object') {
      if (Array.isArray(value.Items)) {
        return value.Items;
      }
      if (Array.isArray(value.Data)) {
        return value.Data;
      }
      if (Array.isArray(value.Result)) {
        return value.Result;
      }
    }

    return [];
  }

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public contentservice: ContentManagementService,
    public session: SessionService,
    private readonly toaster: ToastrService,
    private route: ActivatedRoute,
    private practiceTestService: StudyunitPracticeTestService,
    private examService: ExamManagementService,
  ) {}

  ngOnInit(): void {

    this.addEditForm = this.fb.group({
      practiceTestId: [{ value: '', disabled: true }],
      status: ['', Validators.required],
      subject: [{ value: '', disabled: true }, Validators.required],
      applicableCourses: [[]],
      noOfQuestion : [null],
      totalScore : [0],
    });
    this.addEditForm.get('subject')?.setValue(this.subjectId)
    if (this.PracticeTest) {
      this.addEditForm.patchValue({
        practiceTestId: this.PracticeTest.Course_Test_Id,
        status: this.PracticeTest.Course_Test_Status_Type_Code,
        noOfQuestion: this.PracticeTest.Number_Of_Questions,
      });
      this.studyUnitId= this.PracticeTest.Study_Unit_Id;
      this.studyUnitName = this.PracticeTest.Study_Unit_Name;
      this.studyUnitTopic = this.PracticeTest.Path_Name
    }
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.courseId = +params['c_id'];

      });

    const appliableCoursePlan = {};
    forkJoin({
      statuses: this.examService.getMockExamsStatusTypes().pipe(
        catchError((error) => {
          console.error('Error fetching statuses:', error);
          return of([]);
        })
      ),
      courses: this.contentservice
        .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
        .pipe(
          catchError((error) => {
            console.error('Error fetching courses:', error);
            return of([]);
          })
        ),
      availableCourseType: this.contentservice
        .getCoursePlan$(
          this.session.getUser(),
          this.courseId,
          '',
          'ASSIGNMOCKEXAM',
          '',
          ''
        )
        .pipe(
          catchError((error) => {
            return of({ coursePlan: [] });
          })
        ),
      applicableCoursePlan: this.examService
        .getMockExamApplicableCoursePlan({
          ScreenName: 'ASSIGNMOCKEXAMTOCOURSEPLAN',
          CourseTestID: this.PracticeTest ? this.PracticeTest.Course_Test_Id : null,
          CourseID: this.PracticeTest ? this.courseId : 0,
          CoursePlanID: null,
          SelectedInd: null,
        })
        .pipe(
          catchError((error) => {
            console.error('Error fetching applicable course type:', error);
            return of([]); // ✅ Return an empty array instead of null
          })
        ),
    }).subscribe(
      ({
        statuses,
        courses,
        availableCourseType,
        applicableCoursePlan, // ✅ Ensure this key matches the `forkJoin` observable key
      }: {
        statuses: any;
        courses: any;
        availableCourseType: any;
        applicableCoursePlan: ICoursePlanMockExam[]; // ✅ Corrected key name
      }) => {
        this.statuses = this.asArray<IGetCodes>(statuses);
        this.courses = this.asArray<IGetCodes>(courses);
        this.availableCourseType = this.asArray<any>(availableCourseType?.coursePlan);
        this.selectedCourses = this.PracticeTest?.Course_Plan_Type_Codes ?? [];
        this.CourseAppliableCourseType = this.asArray<string>(this.PracticeTest?.Course_Plan_Type_Codes);
      }
    );

    this.getSubjects()
  }

  getSubjects(){
    this.practiceTestService.getSubject().subscribe(
      (res)=>{
        this.subjects = res;

      },
      (error)=>{
        console.log(error);

      }
    )
  }


  assignStudyUnit() {
    const subjectId = this.addEditForm.getRawValue().subject;

    if (!subjectId) {
      this.toaster.error('Select subject first');
      return;
    }

    const modalRef = this.modalService.open(AssignStudyunitToPracticeTestComponent, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'custom-modal-width-assign-studyunit',
    });

    modalRef.componentInstance.subjectId = subjectId;
    modalRef.componentInstance.courseId = this.courseId;

    // Handle modal close result:
    modalRef.result.then(
      (result) => {
        if (result) {
          // result.id, result.name, result.topic
          console.log('Selected Study Unit:', result);

          this.studyUnitId = result.id;
          this.studyUnitName = result.name; // <-- Add this property in your component
          this.studyUnitTopic = result.topic; // <-- Add this property in your component

          // Do whatever you need with name and topic
        }
      },
      (reason) => {
        // Modal dismissed, do nothing or handle dismiss case
      }
    );

  }


  onCourseChange(event: any) {
    if (event.target.checked) {
      this.selectedCourses.push(event.target.value);
    } else {
      this.selectedCourses = this.selectedCourses.filter(
        (c) => c !== event.target.value
      );
    }
    this.addEditForm.patchValue({ applicableCourses: this.selectedCourses });
  }
  disablecheckboxes(type: string) {
    return !this.availableCourseType.some(
      (ele) => ele.Course_Plan_Type_Code === type
    );
  }
  selectedcheckboxes(type: string) {
    return this.selectedCourses.some((ele) => ele === type);
  }
  checkedCoursePlan(type: string): boolean {
    return (this.CourseAppliableCourseType ?? []).includes(type);
  }

  onSubmit() {
    if (!this.studyUnitId) {
      this.toaster.error('Please select a study unit first.',"",{timeOut:ConstantVars.ToastErrorTimeout});
      return;
    }
    if (this.addEditForm.valid) {
      const payload = {
        LoggedInUser: this.session.getUser(),
        CourseId: this.courseId,
        CourseTestId: this.PracticeTest ? this.PracticeTest.Course_Test_Id :null,
        StudentId: null,
        StudyUnitID: this.studyUnitId,
        TestTypeCode: 'SUPracticeTest',
        TestName: null,
        NumberOfQuestions: this.addEditForm.get('noOfQuestion')?.value,
        TestSequenceNumber: null,
        TotalScore: 0,
        CourseTestStatusTypeCode: this.addEditForm.get('status')?.value,
        NewCourseTestId: null,
        ExamSeriesTypeCode: null,
        UDTStudyUnitPracticeTestApplicableCoursePlan: this.availableCourseType.map(
          (e: any) => {
            return {
              CoursePlanID: +e.Course_Plan_Id,
              SelectedInd: this.selectedcheckboxes(e.Course_Plan_Type_Code)
                ? 'Y'
                : 'N',
            };
          }
        )

      };


      this.practiceTestService.addEditStudyUnitPracticeTest(payload).subscribe(
        (res: any) => {
          this.toaster.success('Mock ExamCreated', '', {
            timeOut: ConstantVars.ToastSucessTimeout,
          });
          this.activeModal.close(this.PracticeTest ? this.PracticeTest.Course_Test_Id:res?.NewCourseTestId);
        },
        (error: any) => {
          this.toaster.error('Something went wrong', '', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
        }
      );
    } else {
      this.addEditForm.markAllAsTouched();
    }
  }

}
